// M3 — Manager tour: Inquiries. 4 steps on inquiry edit page.
export default {
  key: 'M3',
  // No route — M3 only runs when the user is already on an inquiry edit page;
  // HelpMenu uses routePattern to gate visibility, so we never auto-navigate.
  route: null,
  routePattern: /^\/inquiries\/\d+$/,
  steps: [
    {
      id: 'positions',
      target: '[data-tour-id="inquiry.positions-section"]',
      title: 'Positions',
      desc: 'An inquiry can contain multiple positions. Each position is one product to manufacture.',
    },
    {
      id: 'components',
      target: '[data-tour-id="inquiry.components-section"]',
      title: 'Components (BOM)',
      desc: 'Each position can be a composite product with nested sub-components. The tree shows the full bill of materials for this position.',
    },
    {
      id: 'actions',
      target: '[data-tour-id="inquiry.actions-section"]',
      title: 'Manufacturing actions',
      desc: 'The actions list defines the production operations for this position — which workcenter group runs each step and how long it takes.',
    },
    {
      id: 'materials',
      target: '[data-tour-id="inquiry.materials-section"]',
      title: 'Raw materials',
      desc: 'Specify the raw material used by this position. Material can be procured via material orders when the production order is scheduled.',
    },
  ],
}
